import type { HeatmapPoint } from '@/types/dashboard'
import type { WidgetProps } from './WidgetProps'
import { HeatmapGrid } from './HeatmapGrid'

export function ActivityHeatmapWidget({ payload }: WidgetProps) {
  const days = (payload.days ?? []) as HeatmapPoint[]
  const from = typeof payload.from === 'string' ? payload.from : ''
  const to = typeof payload.to === 'string' ? payload.to : ''

  return <HeatmapGrid from={from} to={to} days={days} />
}
